// Billing Management module internationalization - English
export default {
  title: 'Billing Management',
  billNo: 'Bill Number',
  billType: 'Bill Type',
  amount: 'Amount',
  currency: 'Currency',
  dueDate: 'Due Date',
  amountRange: 'Amount Range',
  dueDateRange: 'Due Date Range',
  status: {
    pending: 'Pending',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
    paid: 'Paid'
  },
  types: {
    shipping: 'Shipping Fee',
    customs: 'Customs Duty',
    portCharges: 'Port Charges',
    trucking: 'Trucking Fee'
  },
  actions: {
    confirm: 'Confirm',
    reject: 'Reject',
    exportData: 'Export Data',
    customizeTable: 'Customize Table',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    cancelEdit: 'Cancel Edit',
    back: 'Back',
    delete: 'Delete',
    import: 'Import',
    addFees: 'Add Fees',
    removeFees: 'Remove Fees',
    confirmAdd: 'Confirm Add',
    confirmImport: 'Confirm Import',
    confirmDelete: 'Confirm Delete',
    confirmSubmit: 'Confirm Submit',
    upload: 'Upload',
    refresh: 'Refresh',
    download: 'Download',
    view: 'View',
    batchDownload: 'Batch Download',
    addDept: 'Add Department',
    createReceivable: 'New Receivable',
    createPayable: 'New Payable',
    cancelConfirm: 'Cancel Confirmation',
    submitBpm: 'Submit BPM Approval',
    resubmitBpm: 'Resubmit',
    viewBpm: 'View Approval',
    sendBill: 'Send Bill',
    confirmBill: 'Confirm Bill',
    markPaid: 'Mark as Paid',
    markReceived: 'Mark as Received',
    print: 'Print'
  },
  forms: {
    billNo: 'Bill No.',
    billNoPlaceholder: 'Please enter bill number',
    statusPlaceholder: 'Please select status',
    billTypePlaceholder: 'Please select bill type',
    currencyPlaceholder: 'Please select currency',
    minAmount: 'Min Amount',
    maxAmount: 'Max Amount',
    settlementObject: 'Settlement Party',
    settlementObjectPlaceholder: 'Please enter settlement party',
    invoiceTitle: 'Invoice Title',
    invoiceTitlePlaceholder: 'Please enter invoice title',
    incomeExpenseType: 'Income/Expense Type',
    billDate: 'Bill Date',
    dueDate: 'Due Date',
    counterpartBillNo: 'Counterparty Bill No.',
    inputPlaceholder: 'Please enter',
    paymentEntity: 'Payment Entity',
    paymentEntityPlaceholder: 'Select payment entity',
    supplierBank: 'Supplier Bank',
    supplierBankPlaceholder: 'Select supplier bank',
    supplierBankAccount: 'Supplier Bank Account',
    supplierBankAccountPlaceholder: 'Enter supplier bank account',
    supplierBankAutoHint: 'Auto-filled after selecting settlement party',
    paymentInfo: 'Payment Information',
    remark: 'Remark',
    billRemarkPlaceholder: 'Bill-level remark',
    billCurrencyLabel: 'Bill Currency (Base)',
    deptSelectPlaceholder: 'Please select department',
    feeSearchPlaceholder: 'Search consignment no. / fee name',
    priceChangeNote: 'Price Change Note',
    priceChangeNotePlaceholder: 'Please explain the reason for price changes (if any)',
    reconciliationNo: 'Reconciliation No.',
    reconciliationNoPlaceholder: 'Please enter reconciliation no.',
    consignmentNo: 'Transport Consignment No.',
    reconciliationSupplier: 'Reconciliation Supplier',
    reconciliationSupplierPlaceholder: 'Please enter supplier',
    originalTotalUsd: 'Original Quote Total (USD)',
    currentTotalUsd: 'Reconciliation Total (USD)',
    approvalRemark: 'Approval Remark',
    approvalRemarkPlaceholder: 'Please enter approval remark',
    maxLength100: 'Maximum 100 characters',
    maxLength50: 'Maximum 50 characters',
    requiredSettlementObject: 'Please enter settlement party',
    dueDateAfterBillDate: 'Due date must be later than bill date',
    importFileButton: 'Select File (Excel/CSV)',
    importFormatHint: 'Format: column 1 = department name, column 2 = amount (2 decimal places)',
    importPreviewTitle: 'Preview:',
    settlementFlag: 'Participate in Settlement',
    settlementFlagPlaceholder: 'Please select',
    fileBusinessType: 'File Type',
    hasOriginalPaperInvoice: 'Original Paper Invoice',
    attachment: 'Attachment',
    selectAttachment: 'Select Attachment',
    attachmentUploadTip: 'Click or drag a file here to upload'
  },
  detail: {
    newPayableBill: 'New Payable Bill',
    newReceivableBill: 'New Receivable Bill',
    inclusiveTaxAmount: 'Amount (Incl. Tax)',
    exclusiveTaxAmount: 'Amount (Excl. Tax)',
    taxAmount: 'Tax Amount',
    nonBizFeeAmount: 'Non-business Fee Amount',
    paymentTotalAmount: 'Total Payment Request',
    deptNonBizFee: 'Department Non-business Fees',
    deptFeeSubtotal: 'Department Fee Subtotal',
    feeCurrency: 'Fee Currency',
    originalAmount: 'Original Amount',
    exchangeRateToBill: 'Rate (Fee Currency → {currency})',
    billCurrencyAmount: '{currency} Amount',
    rateLocked: '1.000000',
    settlementBill: 'Settlement Bill',
    billAmountWithCurrency: 'Bill Amount ({currency})',
    addFeeModalTitle: 'Add Fees',
    importDeptFeeModalTitle: 'Import Department Non-business Fees',
    removeFeeModalTitle: 'Remove Fees',
    removeFeeModalContent: 'Remove {count} selected fee item(s)?',
    settlementFilterAlert:
      'Filtered by settlement party "{name}". Only fees with the same party can be selected.',
    addFeeExistingOnBillHint:
      'Fees already on this bill are not listed here (unbilled fees only). New fees must match the bill settlement party.',
    selectedCount: '{count} selected',
    emptyFees: 'No fees yet. Click "Add Fees" to add.',
    emptyDeptFees: 'No department fees',
    emptyBills: 'No bills',
    basicInfo: 'Basic Info',
    externalWriteOffRecord: 'External Write-off Records',
    emptyExternalWriteOffRecord: 'No external write-off records',
    billSlipDetailModalTitle: 'Bill Slip Details',
    emptyBillSlipDetails: 'No bill slip details',
    billSlipRawRequest: 'Raw Request',
    fileHistory: 'File History',
    emptyFileHistory: 'No files',
    externalApprovalHistory: 'External Approval History',
    emptyExternalApprovalHistory: 'No external approval history',
    uploadFileModalTitle: 'Upload Settlement Bill File',
    deleteFileModalTitle: 'Delete file?',
    deleteFileModalContent:
      'File "{name}" will be removed from this bill history. The cloud file will not be physically deleted.',
    deleteFilesModalTitle: 'Delete files?',
    deleteFilesModalContent:
      '{count} selected file(s) will be removed from this bill history. The cloud files will not be physically deleted.',
    feeDetails: 'Fee Details',
    noFeeResults: 'No results',
    selectBillForFees: 'Select a bill above to view fee details'
  },
  billingTab: {
    deleteConfirmTitle: 'Delete this bill?',
    deleteConfirmContent:
      'Bill No.: {billNo}; Settlement Party: {settlementObject}. This cannot be undone. Linked TC fee data will not be affected.',
    bpmModalTitle: 'Submit BPM Approval'
  },
  columns: {
    businessNo: 'Business No.',
    feeName: 'Fee Name',
    incomeExpense: 'Income/Expense',
    payType: 'Payment Type',
    unit: 'Unit',
    paymentEntityCountry: 'Payment Entity Country',
    paymentEntity: 'Payment Entity',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    taxRate: 'Tax Rate',
    referenceNo: 'Business/Customer Ref.',
    dept: 'Department',
    deptName: 'Department Name',
    operation: 'Action',
    billCurrency: 'Bill Currency',
    externalApprovalStatus: 'External Approval Status',
    externalApprovalTime: 'External Approval Time',
    externalApprovalOpinion: 'External Approval Opinion',
    externalRejectReason: 'External Rejection Reason',
    invoiceStatus: 'Invoice Status',
    writeoffStatus: 'Write-off Status',
    bpmApproval: 'BPM Approval',
    origin: 'Source',
    feeType: 'Fee Type',
    region: 'Domestic/Foreign',
    estimatedAmountWithTax: 'Est. Amount (Incl. Tax)',
    baseCurrency: 'Base Currency',
    baseCurrencyAmount: 'Base Currency Amount',
    waybillNo: 'Waybill No.',
    createTime: 'Created At',
    createdBy: 'Created By',
    receiptAction: 'Operation',
    receiptStatus: 'Receipt Status',
    receivedAmount: 'Received Amount',
    unreceivedAmount: 'Unreceived Amount',
    settlementFlag: 'Settlement',
    fileName: 'File Name',
    fileBusinessType: 'File Type',
    hasOriginalPaperInvoice: 'Paper Invoice',
    fileSize: 'Size',
    uploadTime: 'Uploaded At',
    uploadUserId: 'Uploaded By',
    paymentApplicationNo: 'Payment Application No.',
    requestId: 'Request ID',
    account: 'Bank Account',
    paymentMethod: 'Payment Method',
    actualPaymentAmount: 'Actual Payment Amount',
    exchangeRate: 'Exchange Rate',
    writeOffCompleteTime: 'Write-off Complete Time',
    processStatus: 'Process Status',
    errorMessage: 'Failure Reason',
    receiveTime: 'Received At',
    billSlipNo: 'Bill Slip No.',
    billSlipType: 'Bill Slip Type',
    billSlipDate: 'Bill Slip Date',
    billSlipFileUrl: 'Attachment',
    fileId: 'File ID'
  },
  receipt: {
    externalOcrUpload: 'External Invoice OCR',
    externalOcrOpened: 'External invoice OCR upload page opened',
    externalOcrNoUploadUrl: 'External invoice OCR upload URL was not returned',
    externalOcrSelectSingleBill: 'Please select one bill for external invoice OCR',
    externalOcrBillRequired: 'Current receipt bill is missing bill number or bill ID',
    title: 'Bill Receipt — {billNo}',
    batchTitle: 'Batch Receipt',
    historyTitle: 'Receipt History — {billNo}',
    settlementHistoryTitle: 'Receipt History',
    openReceipt: 'Receipt',
    receiptHistory: 'Receipt History',
    batchReceipt: 'Batch Receipt',
    batchReceiptN: 'Batch Receipt ({count})',
    saveReceipt: 'Save Receipt',
    cancel: 'Cancel',
    fullReceipt: 'Full Receipt',
    inputAmount: 'Enter amount',
    inputPlaceholder: 'Please enter',
    dash: '—',
    fullReceived: 'Fully Received',
    partialReceived: 'Partial',
    notReceived: 'Not Received',
    feeCountSelected: '{count} fee(s) selected',
    feeCount: 'fee(s)',
    billCount: 'bill(s)',
    feeSaved: 'Receipt saved for {count} fee(s)',
    billSaved: 'Receipt saved for {count} bill(s)',
    noFeeData: 'No fee data for this bill',
    noBillData: 'No bill data',
    noReceiptHistory: 'No receipt records',
    noReceiptHistoryHint: 'No receipt records. Click "Batch Receipt" to add one.',
    selectFees: 'Select fees and enter receipt amount (cannot exceed receivable amount)',
    selectBills: 'Select bills and enter receipt amount (cannot exceed bill amount)',
    invoiceTypeRequired: 'Please select invoice type',
    invoiceNoRequired: 'Please enter invoice number',
    invoiceDateRequired: 'Please select invoice date',
    exchangeRateRequired: 'Please enter exchange rate',
    billingTitleRequired: 'Please enter billing title',
    receivingTitleRequired: 'Please enter receiving title',
    taxExclusiveAmountRequired: 'Please enter tax-exclusive amount',
    selectAtLeastOneFee: 'Please select at least one fee',
    selectAtLeastOneBill: 'Please select at least one bill',
    fillFeeAmount: 'Please enter receipt amount for "{name}"',
    feeFullyReceived: '"{name}" has no receivable amount, please deselect',
    amountExceed: 'Receipt amount for "{name}" cannot exceed {currency} {amount}',
    billAmountExceed: 'Receipt amount for "{name}" cannot exceed bill amount {currency} {amount}',
    selectBillFirst: 'Please select bills for batch receipt',
    selectBillForHistory: 'Please select bills to view receipt history',
    selectBillWarning: 'No fees found for the selected bills',
    receiptBatches: 'Receipt Batch(es)',
    billAmountLabel: 'Bill Amount',
    totalReceivedLabel: 'Total Received',
    billStatusLabel: 'Bill Status',
    summaryLabel: 'Bills: {billCount} / Receipt Batches: {batchCount}',
    feeName: 'Fee Name',
    feeType: 'Type',
    totalFeeAmount: 'Fee Amount',
    received: 'Received',
    canReceive: 'Receivable',
    thisReceiptAmount: 'Receipt Amount',
    thisReceiptAmountRequired: 'Receipt Amount *',
    billName: 'Bill',
    payable: 'Payable',
    receivable: 'Receivable',
    receiptHistoryColumns: {
      batch: 'Batch',
      invoiceNo: 'Invoice No.',
      invoiceType: 'Invoice Type',
      totalAmount: 'Total Amount',
      amountExcludingTax: 'Amount Excl. Tax',
      taxRate: 'Tax Rate',
      feeCount: 'Fee Count',
      invoiceDate: 'Invoice Date',
      createdBy: 'Created By',
      createdAt: 'Created At',
      billNo: 'Bill No.',
      batchAmount: 'Receipt Amount',
      issuerTitle: 'Issuer'
    },
    invoiceType: 'Invoice Type',
    invoiceNo: 'Invoice No.',
    invoiceDate: 'Invoice Date',
    exchangeRate: 'Exchange Rate',
    billingTitle: 'Billing Title',
    receivingTitle: 'Receiving Title',
    taxExclusiveAmount: 'Amount Excl. Tax',
    taxRate: 'Tax Rate',
    taxAmount: 'Tax Amount',
    totalAmount: 'Total Amount',
    remark: 'Remark',
    attachment: 'Attachment',
    uploadAttachment: 'Upload Invoice (PDF / PNG / JPG / OFD)',
    remarkPlaceholder: 'Optional, max 200 characters',
    billingTitlePlaceholder: 'Enter issuer name',
    receivingTitlePlaceholder: 'Enter recipient name',
    invoiceNoPlaceholder: 'Enter invoice number',
    invoiceTypePlaceholder: 'Select',
    invoiceTypeEnum: {
      vat_special: 'VAT Special Invoice',
      vat_general: 'VAT General Invoice',
      e_general: 'E-General Invoice',
      e_special: 'E-Special Invoice',
      receipt: 'Receipt'
    }
  },
  externalInvoiceSync: {
    action: 'Sync External Invoice Status',
    selectShokzBill: 'Please select Shokz bills (bill numbers starting with AP)',
    filteredNonShokz:
      'Filtered {count} non-Shokz bills (not starting with AP); only Shokz bills (starting with AP) will be synced',
    success:
      'External invoice status sync completed: {successCount} succeeded, {failedCount} failed, {unmatchedCount} unmatched',
    failed: 'External invoice status sync failed'
  },
  enums: {
    receivable: 'Receivable',
    payable: 'Payable',
    billStatus: {
      DRAFT: 'Draft',
      PENDING: 'Pending',
      CONFIRMED: 'Confirmed',
      DISPUTED: 'Disputed',
      PAID: 'Paid',
      CLOSED: 'Closed',
      SENT: 'Sent',
      RECEIVED: 'Received',
      OVERDUE: 'Overdue'
    },
    invoiceStatus: {
      ALL: 'Fully Invoiced',
      PARTIAL: 'Partially Invoiced',
      NONE: 'Not Invoiced'
    },
    externalInvoiceStatus: {
      NOT_INVOICED: 'Not invoiced',
      NORMAL: 'Normal',
      VOIDED: 'Voided',
      RED_FLUSH: 'Red-flushed',
      ABNORMAL: 'Abnormal',
      OUT_OF_CONTROL: 'Out of control',
      UNKNOWN: 'Unknown'
    },
    externalApprovalStatus: {
      APPROVED: 'Approved',
      REJECTED: 'Rejected'
    },
    writeoffStatus: {
      DONE: 'Written Off',
      NONE: 'Not Written Off'
    },
    bpmStatus: {
      none: 'Not Submitted',
      pending: 'Pending Approval',
      approved: 'Approved',
      rejected: 'Rejected',
      approvedDone: 'Approved'
    },
    billOrigin: {
      supplier: 'Supplier Settlement',
      internal: 'Internal'
    },
    region: {
      DOMESTIC: 'Domestic',
      FOREIGN: 'Foreign'
    },
    settlementFlag: {
      Y: 'Yes',
      N: 'No'
    },
    fileBusinessType: {
      PAYMENT_ATTACHMENT: 'Payment Attachment',
      INVOICE: 'Invoice',
      RECEIPT: 'Receipt',
      VOUCHER: 'Voucher',
      OTHER: 'Other'
    }
  },
  common: {
    yes: 'Yes',
    no: 'No'
  },
  messages: {
    searchSuccess: 'Search successful',
    searchFailed: 'Search failed',
    confirmSuccess: 'Bill {billNo} confirmed successfully',
    rejectSuccess: 'Bill {billNo} rejected successfully',
    exportPending: 'Export function under development...',
    customizeTablePending: 'Customize table function under development...',
    feesAdded: '{count} fee item(s) added',
    feesRemoved: 'Removed',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed, please try again',
    paymentEntityCountryRequired: 'Please select a payment entity country for every fee line',
    operationFailed: 'Operation failed',
    deleteFailed: 'Delete failed',
    billConfirmed: 'Bill confirmed',
    billMarkedPaid: 'Marked as paid',
    billMarkedReceived: 'Marked as received',
    billSent: 'Bill sent',
    billDeleted: 'Bill deleted',
    cancelConfirmSuccess: 'Confirmation cancelled',
    bpmSubmitted: 'BPM approval submitted',
    deptFeesImported: '{count} department fee record(s) imported',
    addFeesFirst: 'Please add fees first',
    paymentEntityCountryRequired: 'Please select a payment entity country for every fee',
    feePaymentEntityRequired: 'Please select a payment entity for every fee',
    deletePayableOnlyDraftOrPending: 'Only draft or pending payable bills can be deleted',
    deleteReceivableOnlyDraft: 'Only draft receivable bills can be deleted',
    deleteBillBpmProtected: 'Bills under approval or already approved cannot be deleted',
    priceChangeNoteRequired: 'Please enter price change note',
    reconciliationNoRequired: 'Please enter reconciliation no.',
    reconciliationSupplierRequired: 'Please enter reconciliation supplier',
    reconciliationAmountRequired: 'Please enter reconciliation amount',
    exchangeRateMissing:
      'Exchange rate not found: {currencies} → {currency}. Please maintain the currency pair or enter the rate manually',
    fileReadFailed: 'Failed to read file, please check the format',
    deptListEmpty:
      'Department list is empty. Please configure departments or contact the administrator',
    deptNotFound: 'Department "{name}" does not exist. Please use a name from the dropdown',
    addFeeSettlementObjectMismatch:
      'Only fees with settlement party "{name}" can be added; other parties do not match this bill',
    selectBillsToPrint: 'Please select bill(s) to print',
    noBillPrintTemplates:
      'No bill print templates found. Configure templates with schemaType BILL in system settings',
    loadPrintTemplateFailed: 'Failed to load print templates',
    openPrintTemplateFailed: 'Failed to open print template',
    fileListLoadFailed: 'Failed to load files',
    externalWriteOffHistoryLoadFailed: 'Failed to load external write-off history',
    externalApprovalHistoryLoadFailed: 'Failed to load external approval history',
    selectAttachmentFirst: 'Please select an attachment first',
    selectFileFirst: 'Please select file(s) first',
    fileUploaded: 'File uploaded',
    fileUploadFailed: 'File upload failed',
    fileIdMissing: 'File ID is empty, cannot download',
    fileDownloadFailed: 'File download failed',
    fileDeleted: 'File deleted',
    filesDownloaded: '{count} file download(s) started',
    filesDeleted: '{count} file(s) deleted',
    noBillSlipDetails: 'No bill slip details'
  },
  settlementStatement: {
    tabs: {
      reconciliation: 'Reconciliation',
      statement: 'Bills'
    },
    common: {
      filterTitle: 'Search Criteria',
      queryScheme: 'Query Scheme:',
      schemeDefault: 'default',
      schemeOne: 'Scheme 1',
      search: 'Search',
      reset: 'Reset',
      saveScheme: 'Save Scheme',
      saveSchemeAs: 'Save As Scheme',
      appendQuery: 'Append Query',
      all: 'All',
      dateTo: 'to',
      columnSettings: 'Columns',
      export: 'Export',
      gotIt: 'OK',
      view: 'View',
      confirm: 'Confirm',
      cancelConfirm: 'Cancel Confirmation',
      review: 'Review',
      cancelReview: 'Cancel Review',
      batchUpload: 'Batch Upload Files',
      invoiceReceive: 'Invoice / Receipt',
      writeoff: 'Write-off',
      applyPayment: 'Request Payment',
      etdRange: 'Range',
      etdEquals: 'Equals'
    },
    reconciliation: {
      paymentType: 'Payment Type:',
      feeTypeRegion: 'Fee Region:',
      businessDate: 'Business Date:',
      createBill: 'Create Bill',
      selectFeesFirst: 'Please select fees to create a bill',
      settlementObjectMismatchTitle: 'Settlement Party Mismatch',
      settlementObjectMismatchContent:
        'Selected fees have different settlement parties ({list}). Select fees with the same party only.',
      currencyMismatchTitle: 'Currency Mismatch',
      currencyMismatchContent:
        'Selected fees have different currencies ({list}). Select fees with the same currency only.',
      feeTypeMismatchTitle: 'Income/Expense Type Mismatch',
      feeTypeMismatchContent:
        'Selection includes both receivable and payable fees. Select one income/expense type only.',
      feeTypeUnknown:
        'Cannot determine income/expense type. Filter by receivable or payable and try again.',
      billedFeesTitle: 'Fees Already on Bill',
      billedFeesContent:
        '{billed} of {total} selected fee(s) are already linked to a bill. Select unbilled fees only.'
    },
    statementFilter: {
      payType: 'Payment Type:',
      billStatus: 'Bill Status:',
      selectPayTypeFirst: 'Select payment type first',
      billNo: 'Bill No.:',
      settlementObject: 'Settlement Party:',
      fuzzyQuery: 'Fuzzy search',
      fuzzySearch: 'Fuzzy search'
    },
    billTab: {
      billListLoadFailed: 'Failed to load bills, please try again',
      feeListLoadFailed: 'Failed to load fees, please try again',
      exportPending: 'Export is under development',
      bpmApproved: 'Approved'
    },
    reconciliationColumns: {
      transportOrderNo: 'Transport Consignment',
      feeName: 'Fee Name',
      feeCategory: 'Fee Category',
      exchangeRate: 'Exchange Rate',
      taxIncludedPrice: 'Amount (Incl. Tax)',
      taxExcludedPrice: 'Amount (Excl. Tax)',
      taxAmount: 'Tax Amount',
      updateTime: 'Updated At',
      updateBy: 'Updated By'
    },
    billColumns: {
      billNo: 'Bill No.',
      settlementObject: 'Settlement Party',
      invoiceTitle: 'Invoice Title',
      billCurrency: 'Bill Currency',
      amount: 'Amount',
      payType: 'Income/Expense',
      status: 'Status',
      externalApprovalStatus: 'External Approval Status',
      invoiceStatus: 'Invoice Status',
      writeoffStatus: 'Write-off Status',
      bpmApproval: 'BPM Approval',
      operation: 'Action',
      createdBy: 'Created By',
      createTime: 'Created At'
    }
  },
  expressReconcile: {
    title: 'Express Reconciliation',
    unboundWaybill: 'Unassigned waybill',
    actions: {
      importBill: 'Import Bill',
      confirmBill: 'Confirm Bill',
      parseFile: 'Parse File',
      removeFile: 'Remove',
      previous: 'Previous',
      collapse: 'Collapse'
    },
    carriers: {
      SF: 'SF Express',
      FEDEX: 'FedEx'
    },
    carrierShort: {
      SF: 'SF Express',
      FEDEX: 'FedEx'
    },
    forms: {
      carrier: 'Carrier',
      carrierPlaceholder: 'Select carrier',
      billMonth: 'Bill Month',
      billMonthPlaceholder: 'Select bill month',
      uploadFile: 'Upload Bill File',
      uploadHint: 'Click to select (.xlsx / .xls, ≤ 10 MB, ≤ 2000 rows)',
      remark: 'Remark',
      remarkPlaceholder: 'e.g. April SF bill (supplemental import)',
      searchWaybill: 'Search waybill no.',
      duplicatePolicy: 'Duplicate handling'
    },
    duplicatePolicy: {
      skip: 'Skip duplicates',
      overwrite: 'Overwrite duplicates'
    },
    importModalTitle: 'Import Bill',
    batchInfo: '{carrier} · {month}',
    emptyDescription: 'No reconciliation data. Click "Import Bill" to start.',
    stats: {
      totalWaybills: 'Total Waybills',
      pass: 'Pass',
      diff: 'Difference',
      unmatched: 'Unmatched',
      diffAmountLabel: 'Total Difference:',
      diffAmountHint: '(positive = carrier charged more)',
      filterAll: 'All ({count})',
      filterPass: 'Pass ({count})',
      filterDiff: 'Difference ({count})',
      filterUnmatched: 'Unmatched ({count})'
    },
    columns: {
      waybillNo: 'Waybill No. (Express)',
      expressAmount: 'Carrier Amount (CNY)',
      systemAmount: 'System Amount (CNY)',
      diff: 'Difference (CNY)',
      reconcileStatus: 'Status',
      feeName: 'Fee Name',
      amount: 'Amount (CNY)',
      feeDate: 'Fee Date',
      waybillNoShort: 'Waybill No.'
    },
    status: {
      PASS: 'Pass',
      DIFF: 'Difference',
      UNMATCHED: 'Unmatched'
    },
    drill: {
      waybillLabel: 'Waybill: {waybill}',
      diffTag: 'Diff {amount}',
      noSystemRecord: 'No system record',
      amountMatch: 'Amounts match',
      expressBill: 'Carrier Bill',
      systemRecord: 'System Records',
      total: 'Total:',
      expressTotal: 'Carrier total:',
      systemTotal: 'System total:'
    },
    confirmModal: {
      title: 'Confirm Bill',
      content:
        'Confirming automatically adjusts system fees within tolerance and marks the bill as Confirmed. Continue?'
    },
    preview: {
      summary: 'Parsed {rows} row(s), {waybills} waybill(s)',
      hint: 'Showing first 10 rows only; import includes all data',
      sourceRows: 'Source rows',
      parsedLines: 'Valid fee lines',
      waybills: 'Waybills',
      skippedRows: 'Skipped',
      appendNotice: '{count} import(s) already exist for this carrier and month. This file will be appended.',
      duplicateNotice: '{count} duplicate waybill and fee-name key(s) found. Select how to handle them.',
      skipDetail: 'Skipped: missing waybill {waybill}, missing fee name {feeName}, invalid amount {amount}'
    },
    monthLabel: '{year}-{month}',
    tooltipUnmatchedBlocking: '{count} unmatched item(s) remain; resolve before confirming',
    tooltipDiffBlocking: '{count} difference(s) remain; resolve before confirming',
    tooltipNoDataBlocking: 'No reconciliation data is available for confirmation',
    messages: {
      selectOneApBill: 'Select exactly one payable bill for express reconciliation',
      billNotFound: 'Selected bill not found',
      apOnly: 'Express reconciliation supports payable (AP) bills only',
      pendingApBillOnly: 'Express reconciliation supports pending payable (AP) bills only',
      cnyOnly: 'Express reconciliation supports CNY bills only',
      resultLoadFailed: 'Failed to load reconciliation results',
      waybillDetailLoadFailed: 'Failed to load waybill details',
      confirmBillFailed: 'Failed to confirm bill',
      openDrawerFirst: 'Open express reconciliation and select a payable bill first',
      selectBillFile: 'Please select a bill file',
      fileFormatInvalid: 'Only .xls and .xlsx files are supported',
      fileTooLarge: 'The file must not exceed 10 MB',
      parseFailed: 'Parse failed. Check the carrier, bill month, and fixed template format',
      reselectFile: 'Please select the file again',
      duplicatePolicyRequired: 'Select how duplicate fees should be handled',
      noImportPermission: 'You do not have permission to import express bills',
      noConfirmPermission: 'You do not have permission to confirm reconciled bills',
      importFailed: 'Import failed, please try again',
      importSuccess:
        'Import complete. Compared {total} waybill(s): {pass} passed, {diff} differ, {unmatched} unmatched',
      defaultFeeName: 'Fee'
    }
  }
}
